<template>
  <container-app>
    <header-app
      to="home"
      :title="$t('orders')"
      class="header-brand"
    ></header-app>
    <wrap>
      <div>
        <button
          type="button"
          class="btn m-1 btn-light"
          :class="{ btnorderselected: btn_selected === 0 }"
          @click="pending()"
        >
          {{ $t("Inprogress") }}
        </button>
        <button
          type="button"
          class="btn m-1 btn-light"
          :class="{ btnorderselected: btn_selected === 1 }"
          @click="history()"
        >
          {{ $t("History") }}
        </button>
      </div>
      <div class="row">
        <template v-for="(order, i) in map_orders">
          <order-card :key="i" :order="order" />
        </template>
      </div>
    </wrap>
    <loading-location v-if="loading"></loading-location>
    <br />
    <button
      type="button"
      class="btn btn-round center"
      v-if="loadmore"
      @click="load_more()"
    >
      {{ $t("more") }}
    </button>
  </container-app>
</template>
<script>
import store from "@/store";
export default {
  middleware: "auth",
  data: () => ({
    next_page: 1,
    loadmore: true,
    map_orders: [],
    status: [0, 1, 2, 3],
    btn_selected: 0,
  }),
  computed: {
    loading() {
      return store.getters["orders/loading"];
    },
    orders() {
      return store.getters["orders/orders"];
    },
    meta() {
      return store.getters["orders/meta"];
    },
  },
  methods: {
    pending() {
      this.btn_selected = 0;
      (this.status = [0, 1, 2, 3]), this.LoadData(false);
    },

    history() {
      this.btn_selected = 1;
      this.status = [4];
      this.LoadData(false);
    },
    async LoadData(next) {
      let data = {
        next_page: this.next_page,
        limit: 10,
        status: this.status,
      };
      if (!next) {
        this.loadmore = true;
        data.next_page = 1;
        this.map_orders = [];
      }
      await store.dispatch("orders/getOrders", data);
      if (this.orders.length > 0) {
        this.orders.forEach((el) => {
          this.map_orders.push(el);
        });
      } else {
        this.loadmore = false;
      }
      if (this.next_page >= this.meta.last_page) {
        this.loadmore = false;
      } else {
        this.loadmore = true;
      }
      if (this.status === 0) {
        this.$store.dispatch("nav/setPendingNumber", this.meta.total);
      }
    },
    load_more() {
      var vm = this;
      vm.next_page = vm.meta.current_page + 1;
      if (vm.next_page > vm.meta.last_page) {
        vm.loadmore = false;
        return;
      }
      vm.LoadData(true);
    },
  },
  mounted() {
    this.LoadData(false);
  },
};
</script> 